<material-navbar menuPosition="custom-page-navbar" *ngIf="!settings.get('vebto.customPages.hideNavbar') && showNavbar"></material-navbar>
<div class="page-body container article-body" [innerHTML]="body$ | async"></div>